import React from "react";
import { Loader2 } from "lucide-react";

export function Loader({ label = "Chargement..." }) {
  return <div className="flex items-center justify-center py-20 text-slate-400"><Loader2 className="h-5 w-5 animate-spin mr-2" />{label}</div>;
}

export function PageHeader({ title, subtitle, action }) {
  return (
    <div className="flex flex-wrap items-start justify-between gap-4 mb-6">
      <div>
        <h1 className="font-heading font-bold text-2xl sm:text-3xl text-slate-900" data-testid="page-title">{title}</h1>
        {subtitle && <p className="mt-1 text-slate-500">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}

export function StatCard({ icon: Icon, label, value, tone = "primary", onClick, testid }) {
  const tones = {
    primary: "bg-primary/10 text-primary", accent: "bg-accent/10 text-accent",
    emerald: "bg-emerald-50 text-emerald-600", amber: "bg-amber-50 text-amber-600", rose: "bg-rose-50 text-rose-600",
  };
  return (
    <div onClick={onClick} data-testid={testid}
      className={`bg-white rounded-xl border border-slate-200 p-5 flex items-center gap-4 ${onClick ? "cursor-pointer hover:shadow-md hover:border-slate-300 transition-all" : ""}`}>
      {Icon && <div className={`h-11 w-11 rounded-lg flex items-center justify-center shrink-0 ${tones[tone]}`}><Icon className="h-5 w-5" /></div>}
      <div><p className="text-2xl font-bold text-slate-900 font-mono-metric leading-none">{value}</p><p className="mt-1 text-sm text-slate-500">{label}</p></div>
    </div>
  );
}

export function EmptyState({ icon: Icon, title, text, action }) {
  return (
    <div className="text-center py-16 bg-white rounded-xl border border-dashed border-slate-200">
      {Icon && <Icon className="h-10 w-10 text-slate-300 mx-auto" />}
      <p className="mt-3 font-medium text-slate-700">{title}</p>
      {text && <p className="mt-1 text-sm text-slate-400 max-w-sm mx-auto">{text}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}

const STATUS_TONES = {
  "Nouveau": "bg-blue-50 text-blue-700 border-blue-200", "Demande reçue": "bg-blue-50 text-blue-700 border-blue-200",
  "En attente": "bg-slate-100 text-slate-600 border-slate-200", "À analyser": "bg-slate-100 text-slate-600 border-slate-200",
  "En cours d'attribution": "bg-amber-50 text-amber-700 border-amber-200", "Attribuée": "bg-indigo-50 text-indigo-700 border-indigo-200",
  "Confirmée": "bg-emerald-50 text-emerald-700 border-emerald-200", "En cours": "bg-cyan-50 text-cyan-700 border-cyan-200",
  "Terminée": "bg-slate-100 text-slate-500 border-slate-200", "Refusée": "bg-rose-50 text-rose-700 border-rose-200",
  "Annulée": "bg-rose-50 text-rose-700 border-rose-200", "Pris en charge": "bg-amber-50 text-amber-700 border-amber-200",
  "Rappel effectué": "bg-cyan-50 text-cyan-700 border-cyan-200", "Résolu": "bg-emerald-50 text-emerald-700 border-emerald-200",
  "À contacter": "bg-amber-50 text-amber-700 border-amber-200", "Contacté": "bg-cyan-50 text-cyan-700 border-cyan-200",
  "Qualifié": "bg-indigo-50 text-indigo-700 border-indigo-200", "Compte créé": "bg-emerald-50 text-emerald-700 border-emerald-200",
  "Client": "bg-emerald-50 text-emerald-700 border-emerald-200", "Perdu": "bg-rose-50 text-rose-700 border-rose-200",
};
export function StatusBadge({ status }) {
  return <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${STATUS_TONES[status] || "bg-slate-100 text-slate-600 border-slate-200"}`}>{status}</span>;
}
